import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSettingService {
  // use localStorage for localstore
  // don't care about user id here
  private cachedKey: { [key: string]: any } = {};

  private settingUpdatedSub = new Subject<{ key: UserSettings, value: any }>();
  settingUpdate$ = this.settingUpdatedSub.asObservable();

  constructor() { }

  setSetting(key: UserSettings, value: any) {
    if (this.cachedKey['' + key] != value) {
      this.cachedKey['' + key] = value;
      this.settingUpdatedSub.next({ key: key, value: value })
    }
  }
  getSetting(key: UserSettings) {
    return this.cachedKey['' + key];
  }
}

export enum UserSettings {
  showFolderPermission
};
